import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, put, PutEffect, select } from "redux-saga/effects";
import { clearString } from "../../../utils/functions";
import { automaticApi, getUUID } from "../../../settings/api";
import { ReducersTypes } from "@/redux/reducers/Models";
import { jwtDecode } from "jwt-decode";
import { refresh } from "@/redux/ducks/customer";

export interface Fetch {
    pin: string;
    callback: (success: boolean, errorMessage?: string) => void;
}

export interface ValidatePinRegisterDeviceAction {
    type: string;
    payload: Fetch;
}

const getCustomerReducer = (state: ReducersTypes) => state.customerReducer;

export default function* validatePinRegisterDevice({
    payload,
}: ValidatePinRegisterDeviceAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        // @ts-expect-error
        const customer: ReducersTypes['customerReducer'] = yield select(getCustomerReducer);

        const uuid = yield call(getUUID);

        const {
            NRC,
        }: {
            NRC: string;
        } = jwtDecode(customer?.refreshTokenTemporary!);

        const headers = {
            accesstoken: customer?.accessTokenTemporary,
            refreshtoken: customer?.refreshTokenTemporary,
            codigocliente: NRC,
        };

        const response = yield call(automaticApi.post, "/login-extended/v1/pin/valida", {
            actionId: 1020,
            cpf: clearString(customer?.username!),
            pin: payload.pin,
        }, {headers});

        const responseRegisterDevice = yield call(automaticApi.post, `/devicecontrol/v1/register`, {
            cpf: clearString(customer?.username!),
            uuid,
            pin: payload.pin,
            hsacc: response?.data?.hsacc,
        }, { headers });

        if (responseRegisterDevice?.data?.status?.codigoRetorno === 200) {
            yield put(refresh({ callback: payload.callback }));
        } else {
            yield call(payload.callback, false, "error");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}